import { fmtUsdDisplay, pctDisplayNumber } from './termSheetFormatters';

export const FUNDING_FEE_TYPE_USD = 'usd';
export const FUNDING_FEE_TYPE_PCT = 'pct';

function isFilledNumber(value) {
  if (value === '' || value == null) {
    return false;
  }
  return Number.isFinite(Number(value));
}

export function inferFundingFeeType(fields) {
  if (
    fields.fundingFeeType === FUNDING_FEE_TYPE_USD ||
    fields.fundingFeeType === FUNDING_FEE_TYPE_PCT
  ) {
    return fields.fundingFeeType;
  }
  if (isFilledNumber(fields.fundingFeeUsd)) {
    return FUNDING_FEE_TYPE_USD;
  }
  if (isFilledNumber(fields.fundingFeePct)) {
    return FUNDING_FEE_TYPE_PCT;
  }
  return '';
}

export function hasFundingFeeUsd(fields) {
  return (
    inferFundingFeeType(fields) === FUNDING_FEE_TYPE_USD &&
    isFilledNumber(fields.fundingFeeUsd)
  );
}

export function hasFundingFeePct(fields) {
  return (
    inferFundingFeeType(fields) === FUNDING_FEE_TYPE_PCT &&
    isFilledNumber(fields.fundingFeePct)
  );
}

function usdOrPlaceholder(value) {
  const formatted = fmtUsdDisplay(value);
  return formatted == null ? '[]' : formatted.replace(/^\$/, '');
}

function pctOrPlaceholder(value) {
  const pct = pctDisplayNumber(value);
  return pct == null ? '[]' : pct;
}

function installmentLabel(count) {
  if (count === 1) {
    return 'month';
  }
  return 'months';
}

export function buildFundingFeePayablePhrase(fields) {
  const installments = Number(fields.fundingFeeInstallments);
  if (!Number.isFinite(installments) || installments <= 0) {
    return 'payable in equal instalments across [] months';
  }
  return `payable in equal instalments across ${installments} ${installmentLabel(installments)}`;
}

export function buildFundingFeeClause(fields, getUsd = usdOrPlaceholder, getPct = pctOrPlaceholder) {
  const payable = buildFundingFeePayablePhrase(fields);
  const feeType = inferFundingFeeType(fields);

  if (feeType === FUNDING_FEE_TYPE_USD) {
    return `One time fee of [US $${getUsd(fields.fundingFeeUsd)}], ${payable}`;
  }
  if (feeType === FUNDING_FEE_TYPE_PCT) {
    return `One time fee of ${getPct(fields.fundingFeePct)}% of the total investment size amount, ${payable}`;
  }

  return `One time fee of [US $${getUsd('')}] [OR] [${getPct('')}% of the total investment size amount], ${payable}`;
}

export function buildFundingFeeClauseDocx(fields, fmtUsdDocx, fmtPctDocx) {
  const payable = buildFundingFeePayablePhrase(fields);
  const feeType = inferFundingFeeType(fields);

  if (feeType === FUNDING_FEE_TYPE_USD) {
    return `One time fee of US $${fmtUsdDocx(fields.fundingFeeUsd)}, ${payable}`;
  }
  if (feeType === FUNDING_FEE_TYPE_PCT) {
    return `One time fee of ${fmtPctDocx(fields.fundingFeePct)}% of the total investment size amount, ${payable}`;
  }

  return buildFundingFeeClause(fields, fmtUsdDocx, fmtPctDocx);
}
